var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero',{attrs:{"id":"inicio"}}),_c('About',{attrs:{"id":"about"}}),_c('LogosMarcas'),_c('OurServices',{attrs:{"id":"services"}}),_c('WhyChoose',{attrs:{"id":"whyus"}}),_c('WhatWeDo',{attrs:{"id":"metricas"}}),_c('ContactUs',{attrs:{"id":"contact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }